const ITEMS = [
  "Porotta",
  "Idiyappam",
  "Frozen Snacks",
  "God's Own Country",
  "Kerala Curries",
  "European Hubs",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="bg-black py-5 overflow-hidden border-y border-kera-gold/30" data-testid="editorial-marquee">
      <div className="kera-marquee-track flex whitespace-nowrap w-max">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display font-semibold uppercase tracking-wide text-kera-gold text-lg sm:text-xl px-6">{item}</span>
                <span className="h-1.5 w-1.5 rotate-45 bg-white/60" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
